module.exports = __webpack_public_path__ + "media/newstyle/images/3000-outlets-aus-63614f755c50a719989c0c593bc56daa.svg";